var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"groups-list-tree-container",attrs:{"data-testid":"nested-groups-projects-list"}},[_c('group-folder',{attrs:{"groups":_vm.groups,"action":_vm.action}}),_vm._v(" "),_c('pagination-links',{staticClass:"gl-mt-3 gl-flex gl-justify-center",attrs:{"change":_vm.change,"page-info":_vm.pageInfo}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }